
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/l/insolvenzen",
      function () {
        return require("private-next-pages/l/insolvenzen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/l/insolvenzen"])
      });
    }
  